import { atom } from 'jotai';
import { IZone } from '../services/zoneService';

export const zonesAtom = atom<IZone[]>([]);

export const zonesLoadedAtom = atom<boolean>(false);
